/**
 * 合作備忘錄條款預設值
 *
 * 逐字取自《文案撰寫外包合作備忘錄》原始文件，不改寫、不重新編號。
 * 新增備忘錄時帶入這份文字，之後逐份存進 memos.terms；
 * 改這裡只影響「之後新建的」，已經簽出去的合約不受影響。
 *
 * {{匯款帳戶}} 是唯一的標記，列印時換成帳戶表格——原文那一段本來就是表格，
 * 沒辦法用純文字表達。其餘一字未動。
 */
export const MEMO_ACCOUNT_MARKER = '{{匯款帳戶}}'

export const DEFAULT_MEMO_TERMS = `甲方委託乙方所執行之文案撰寫相關工作事宜，經雙方同意所訂立之合作備忘錄如下：

第一條：標的
甲方委託乙方所執行之文案撰寫工作相關事宜
１、乙方須依據甲方所提供之主題與大綱撰寫相關內容文案，除乙方撰寫前告知甲方有修改之需求與得到甲方同意，否則乙方不得擅自修改主題與大綱。
２、甲方有權要求乙方修改乙方所提供之稿件內容，修改上限次數為兩次。
３、乙方不可任意上傳甲方之文案資料至網路上或提供檔案給第三方。

第二條：合約期限
１、合約有效期間：自民國　　年　　月　　日起，至自民國　　年　　月　　日止。
２、若乙方未能依照期限繳交稿件，須提前向甲方說明且經甲方同意後，延長交稿之期限。乙方除甲方同意或不可抗力之因素外，逾期交稿，甲方有權延遲給付乙方費用。

第三條：執行方式
甲方代表與乙方談定需求後，乙方需出具報價單交於甲方，甲方出具發包單後，乙方始可開始製作。

第四條：驗收方式
乙方完成撰寫後應立即通知甲方驗收，並須完成甲方指定之修改事項與確認後，甲方才會開始進入請款流程。

第五條：著作財產權
１、乙方為甲方製作之內容，不得違反著作權法。(本法主管機關為經濟部、著作權業務，由經濟部指定專責機關辦理。)
２、乙方交付文案於甲方後，甲方即取得乙方所撰寫該文案之著作財產權。

第六條：費用給付
雙方約定每月 25 日前結算已完成的文案總價款。乙方應於帳務結算日前提供請款單向甲方請款。如超過每月 25 日後才完成請款，則延至下一個結算日請款，以此類推。甲方於收到請款單後，須於次月 5 日前寄出次月月底的支票；或於次月起算，次月月底將款項匯入乙方所指定之帳戶中。如遇例假日，則往後順延。

例: 2 月 25 日之前完成的文案總價款，在完成請款程序後，甲方需於 3 月 5 日前寄出 3 月 31 日之期票；或於 3 月 31 日匯款至乙方帳戶。

匯款金額皆為含稅價，甲方以匯款方式將款項匯入乙方帳戶,帳戶資料如下：
${MEMO_ACCOUNT_MARKER}
PS: 個人請款需附上銀行存摺和個人身份證正反面影本，且單次給付達 20,000 元,按費率 2.11%就源扣取並繳納補充保險費。(公式：計費所得或收入 ×費率 2.11%)
所得人如果是境內居住的個人，按給付額扣繳 10%，但是如果每次應扣繳稅額不超過 2,000 元的話，可以免予扣。
*所得稅各類扣繳(單次給付＞ 20,000 元) ：10%
*補充保險費率 (單次給付 ≧ 20,000 元) ：2.11%

第七條：保密約定
乙方同意因參與本專案而知悉或持有甲方之商業機密及其他機密資訊，負有保密務，乙方不得以任何方法洩漏或公開予其他第三人，亦不得為自己或其他人之利益，使用該資訊。乙方違反本契約之約定者，甲方有權立即終止本契約，若甲方受有損害時，甲方並得向乙方請求損害賠償。

第八條：合約分執
本合約一式二份，其內容經甲乙雙方確認無誤後，分別簽署如下，各執一份為憑。`

/**
 * 有權讓公司合約專用章印上文件的管理員。
 *
 * 公司章等同對外的正式承諾，所以不是「任何管理員核准就蓋」——必須是這個人核准的
 * 才帶章（比對 memos.reviewed_by，核准時存的是操作者 email）。日後換人或要多一位
 * 授權者，改這個陣列即可，不必動列印版面。
 */
export const SEAL_APPROVERS = ['alibaba@mywonder.com']

/** 甲方（我方）簽署資料，取自原始文件 */
export const PARTY_A = {
  name: '崴浤科技股份有限公司',
  address: '台中市北屯區崇德路 2 段 252 號 8 樓',
  phone: '04-22416227',
  taxId: '53990298',
  rep: '徐維鴻',
}
